import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent } from '@mui/material';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

//TODO: generic input dialog for location and folder
export default function LocationNameInputDialog(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [newLocationName, setNewLocationName] = useState('');
    const [locationNameErrorMsg, setLocationNameErrorMsg] = useState('');
    const [savingOnProgress, setSavingOnProgress] = useState(false);
    const { t } = useTranslation();

    const handleChange = (event) => {
        setLocationNameErrorMsg('');
        setNewLocationName(event.target.value);
    };

    const confirmLocationName = () => {
        if (!!newLocationName && newLocationName.length > 3) {
            setSavingOnProgress(true);
            props.confirm(newLocationName);
        } else {
            setLocationNameErrorMsg(t('general.locationNameTooShort'));
        }
    };

    const cancelLocationName = () => {
        props.cancel();
    };

    const onClose = () => {
        if (!savingOnProgress) props.cancel();
    };

    useEffect(() => {
        if (!props.dialogOpen) {
            setSavingOnProgress(false);
        }
    }, [props.dialogOpen]);

    return (
        <Dialog
            onClose={onClose}
            aria-labelledby="simple-dialog-title"
            open={props.dialogOpen}
            fullWidth={true}
            maxWidth={'md'}
            fullScreen={fullScreen}>
            <DialogContent dividers>
                <TextField
                    error={locationNameErrorMsg.length > 0}
                    id="standard-multiline-flexible"
                    label={t('location.locationName')}
                    sx={{ width: '100%' }}
                    onChange={handleChange}
                    margin="normal"
                    name={'location-name'}
                />
                {locationNameErrorMsg.length > 0 && <Alert severity="warning">{locationNameErrorMsg}</Alert>}
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="primary"
                    name="btn-confirm-location-name"
                    onClick={confirmLocationName}
                    sx={{ m: 1 }}
                    disabled={savingOnProgress}
                    endIcon={savingOnProgress ? <CircularProgress color={'secondary'} size={'1rem'} /> : ''}>
                    {t('buttons.save')}&nbsp;
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    name="btn-cancel-location-name"
                    onClick={cancelLocationName}
                    sx={{ m: 1 }}
                    disabled={savingOnProgress}>
                    {t('buttons.cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
